import React from "react";
import { useSelector } from "react-redux";
import RootState from "../../../redux/states/root.state";

// Determinate progress shown while a report's full date range is being fetched.
// The fetch thunk buffers all pages and commits once, so this bar is the only
// feedback during loading; the graph/table render a single time when it reaches 100%.
const ReportLoadingProgress: React.FC = () => {
  const { loadingProgress } = useSelector((state: RootState) => state.spaHistory);
  const value = Math.min(100, Math.max(0, loadingProgress ?? 0));

  return (
    <div className="dt-state">
      <div className="rp-progress" role="progressbar" aria-label="Loading report" aria-valuemin={0} aria-valuemax={100} aria-valuenow={value}>
        <div className="rp-progress-bar" style={{width: `${value}%`}}/>
      </div>
      <span className="rp-progress-text">Loading report… {value}%</span>
    </div>
  );
};

export default ReportLoadingProgress;
